module.exports = __webpack_public_path__ + "files/15765b3887609dc20a72d85c69c6afbf.png";